import gql from "graphql-tag";

export const PURCHASE_NUMBER = gql`
  mutation($forwardTo: String!, $number: String!) {
    purchase_phone_number(forwardTo: $forwardTo, number: $number)
  }
`;
